import { render, staticRenderFns } from "./CityCarousel.vue?vue&type=template&id=7c0f1392&"
import script from "./CityCarousel.vue?vue&type=script&lang=js&"
export * from "./CityCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})
